const spanishMessages = {
  ra: {
    login: {
      formTitle: 'INICIO DE SESIÓN',
      formRecoverTitle: 'RECUPERAR CONTRASEÑA',
    },
    draft: {
      name: 'Mis Eliminadas',
    },

    action: {
      selectExisting: 'Seleccionar uno extistente',
      add: 'Añadir',
      add_filter: 'Añadir filtro',
      back: 'Ir atrás',
      bulk_actions:
        '1 item seleccionado |||| %{smart_count} items seleccionados',
      cancel: 'Cancelar',
      clear_input_value: 'Limpiar valor',
      clone: 'Clonar',
      close: 'Cerrar',
      close_menu: 'Cerrar menú',
      confirm: 'Confirmar',
      create: 'Crear',
      delete: 'Eliminar',
      edit: 'Editar',
      expand: 'Expandir',
      export: 'Exportar',
      list: 'Listar',
      open_menu: 'Abrir menú',
      refresh: 'Refrescar',
      remove: 'Borrar',
      remove_filter: 'Borrar filtro',
      save: 'Guardar',
      search: 'Buscar',
      show: 'Mostrar',
      sort: 'Ordenar',
      undo: 'Deshacer',
      unselect: 'Deseleccionar',
      create_item: 'Crear',
      update: 'Actualizar',
      download: 'Descargar',
      share: 'Compartir',
    },
    auth: {
      auth_check_error: 'Por favor inicie sesión para continuar',
      logout: 'Cerrar Sesión',
      password: 'Contraseña',
      sign_in: 'Iniciar sesión',
      recovery: 'RECUPERAR',
      sign_in_error: 'La autenticación falló, por favor, vuelva a intentarlo',
      user_menu: 'Perfil',
      username: 'Nombre de usuario',
      email: 'Email',
      forgetPassword: 'Olvidé mi contraseña',
    },
    boolean: {
      true: 'Sí',
      false: 'No',
      null: ' ',
    },
    input: {
      file: {
        upload_several:
          'Arrastre algunos archivos para subir o haga clic para seleccionarlos.',
        upload_single:
          'Arrastre un archivo para subir o haga clic para seleccionarlo.',
      },
      image: {
        related: 'Related pictures',
        upload_several:
          'Arrastre algunas imagénes para subir o haga clic para seleccionarlas.',
        upload_single:
          'Arrastre alguna imagen para subir o haga clic para seleccionarla.',
      },
      references: {
        all_missing: 'No se pueden encontrar datos de referencias.',
        many_missing:
          'Al menos una de las referencias asociadas parece no estar disponible.',
        single_missing: 'La referencia asociada no parece estar disponible.',
      },
      password: {
        toggle_visible: 'Ocultar contraseña',
        toggle_hidden: 'Mostrar contraseña',
      },
    },
    message: {
      about: 'Acerca de',
      are_you_sure: '¿Está seguro?',
      bulk_delete_content:
        '¿Seguro que quiere eliminar este %{name}? |||| ¿Seguro que quiere eliminar estos %{smart_count} items?',
      bulk_delete_title:
        'Eliminar %{name} |||| Eliminar %{smart_count} %{name} items',
      delete_content: '¿Seguro que quiere eliminar este item?',
      delete_title: 'Eliminar %{name} #%{id}',
      details: 'Detalles',
      error:
        'Se produjo un error en el cliente y su solicitud no se pudo completar',
      invalid_form:
        'El formulario no es válido. Por favor verifique si hay errores',
      loading: 'La página se está cargando, espere un momento por favor',
      no: 'No',
      not_found:
        'O bien escribió una URL incorrecta o siguió un enlace incorrecto.',
      yes: 'Sí',
      unsaved_changes:
        'Algunos de sus cambios no se guardaron. ¿Está seguro que quiere ignorarlos?',
    },
    navigation: {
      next: 'Siguiente',
      no_more_results:
        'El número de página %{page} está fuera de los límites. Pruebe la página anterior.',
      no_results: 'No se han encontrado resultados',
      page_out_from_begin: 'No puede ir antes de la página 1',
      page_out_from_end: 'No puede ir después de la última página',
      page_out_of_boundaries: 'Número de página %{page} fuera de los límites',
      page_range_info: '%{offsetBegin} - %{offsetEnd} de %{total}',
      page_rows_per_page: 'Filas por página:',
      prev: 'Anterior',
      skip_nav: 'Saltear navegación',
    },
    sort: {
      sort_by: 'Ordenar por %{field} %{order}',
      ASC: 'ascendente',
      DESC: 'descendente',
    },
    notification: {
      bad_item: 'Elemento incorrecto',
      canceled: 'Acción cancelada',
      created: 'Elemento creado',
      data_provider_error:
        'Error del proveedor de datos. Consulte la consola para más detalles.',
      deleted: 'Elemento borrado |||| %{smart_count} elementos borrados.',
      http_error: 'Error de comunicación con el servidor',
      item_doesnt_exist: 'El elemento no existe',
      logged_out: 'Su sesión ha finalizado, vuelva a conectarse.',
      updated:
        'Elemento actualizado |||| %{smart_count} elementos actualizados',
      i18n_error:
        'No se pudieron cargar las traducciones para el idioma especificado',
    },
    page: {
      create: 'Crear %{name}',
      dashboard: 'Dashboard',
      edit: '%{name} #%{id}',
      empty: 'Sin %{name} todavía.',
      error: 'Algo salió mal',
      invite: '¿Quiere agregar una?',
      list: 'Lista de %{name}',
      loading: 'Cargando...',
      not_found: 'No encontrado',
      show: '%{name} #%{id}',
    },
    validation: {
      email: 'Debe ser un correo electrónico válido',
      maxLength: 'Debe contener %{max} caracteres o menos',
      maxValue: 'Debe ser %{max} o menos',
      minLength: 'Debe contener %{min} caracteres al menos',
      minValue: 'Debe ser al menos %{min}',
      number: 'Debe ser un número',
      oneOf: 'Debe ser uno de: %{options}',
      regex: 'Debe coincidir con un formato específico (regexp): %{pattern}',
      required: 'Requerido',
    },
    menu: {
      list: 'Listado',
      edit: 'Editar',
      show: 'Ver',
    },
    home: {
      title: 'Home',
    },
    register: {
      title: '¡Bienvenido!',
      subtitle:
        'Confirme los datos precargados por el Veterinario para crear su cuenta.',
      name: 'Nombre',
      rut: 'RUT',
      email: 'Email',
      phone: 'Teléfono',
      password: 'Ingrese una contraseña',
      password_confirm: 'Confirme la contraseña',
      sign_in: 'confirmar y registrarme',
    },
    forgot: {
      title: 'Recuperar contraseña',
      subtitle: 'Ingrese su email para poder realizar el cambio.',
      email: 'Email',
      button: 'Cambiar contraseña',
      password: 'Ingrese una contraseña',
      password_confirm: 'Confirme la contraseña',
      recovery_helper: 'Se te enviará un correo para restablecer la contraseña',
    },
  },
  emptyPage: {
    title: 'No hay reportes que coincidan con los criterios de búsqueda.',
    subtitle: '',
  },
  forbidden: {
    title: '¡Lo sentimos! Pero no tenes permisos para acceder acá',
    subtitle: 'Te invitamos a volver a navegar en nuestra web.',
    btnText: 'Volver al dashboard',
  },
  errors: {
    not_goal_found: 'No hay un objetivo seteado para este mes',
    goal_not_found: 'No hay un objetivo seteado para este mes',
    team_not_found: 'No tenés asignado ningún equipo',
    default:
      'Se produjo un error en el cliente y su solicitud no se pudo completar',
  },
  resources: {
    dashboard: {
      welcome: {
        title: '¡Bienvenido %{name}!',
        goal_month: 'Objetivo del mes',
        percentage_completed: 'completado del objetivo',
        unless_goal: 'Sin objetivo seteado',
        title_top_notes: 'Top notas',
        teams: 'Equipos',
        members: 'Redactores',
        points: 'Puntos acumulados',
        team: 'Equipo',
        role: 'Rol',
      },
      list: {
        card_graphic: {
          title: 'Resumen del mes',
          btn: 'Ver reportes',
          fields: {
            visits: 'Vistas',
            notes: 'Notas',
            rfv: 'Calidad',
            subscribers: 'Suscriptores',
          },
        },
        top_team_progress: {
          no_data:
            'Se produjo un error, por favor intente nuevamente más tarde.',
          title: 'Progreso de los equipos',
          fields: {
            top: 'Top',
            team: 'Equipo',
            members: 'Miembros',
            visits: 'Vistas',
            notes: 'Notas',
            rfv: 'Calidad',
            subscribers: 'Suscriptores',
            progress: 'Progreso total',
          },
        },
      },
    },
    reports: {
      titleTeams: 'Reportes por equipo',
      titleSections: 'Reportes por sección',
      list: {
        title_top_notes: 'Top notas del mes',
        graphic_title: 'Resumen de variable',
        results_title: 'Resultados',
        error_message: 'El rango de fechas elegido es inválido',
      },
      fields: {
        top: 'Top',
        notes: 'Notas',
        team: 'Equipo',
        section: 'Sección',
        author: 'Redactor',
        visits: 'Vistas',
        rfv: 'Calidad',
        subscribers: 'Suscriptos',
      },
    },
    score: {
      list: {
        title: 'Puntaje',
        resultsTeam_title: 'Resultados por equipo',
        resultsEditor_title: 'Resultados por redactores',
        summaryScore_title: 'Resumen de puntos',
        evolution_title: 'Evolución de puntos',
        empty_message: 'No se encuentran resultados',

        search: 'Buscar',
        fields: {
          all: 'Todos',
          top: 'Top',
          team: 'Equipo',
          editor: 'Redactor',
          points: 'Puntos del mes',
          plus: 'Adicional',
          total: 'Total del mes',
          accumulated: 'Acumulado',
          month: 'Mes',
          notes: 'Notas',
          visits: 'Vistas',
          rfv: 'Calidad',
          subscribers: 'Suscriptos',
        },
      },
    },
    members: {
      name: 'Miembro',
      list: {
        search: 'Buscar',
      },
      create: {
        manager: 'Gerente',
        tooltip:
          'Este campo es para el ID externo que identifica al miembro en un sistema externo.',
      },
    },
    teams: {
      title: 'Equipos',
      name: 'Equipo',
      list: {
        search: 'Buscar',
      },
      create: {
        title: 'Nuevo equipo',
      },
    },
    goals: {
      name: 'Objetivos',
      create: {
        title: 'Nuevo objetivo',
        titles: {
          step1: 'Configuración de objetivo',
          step1_subtitle: 'Distribución por equipo',
          step2: 'Ponderación del puntaje',
        },
        loading: 'El formulario se está cargando, espere un momento...',
        step1_error_limit: 'Superaste el límite',
        step1_limit: 'Sumá 100% en cada variable',
      },
      list: {
        title: 'Objetivos',
        noGoals: 'No hay objetivos para el equipo... ¡Todavía!',
        noGoalsSub:
          'Asigna los objetivos del mes a tus equipos y sigue su progreso. ¡Comencemos a crear juntos el éxito!',
        search: 'Buscar',
      },
      edit: {
        title: 'Editar objetivo',
      },
      fields: {
        month: 'Mes',
        create_team: 'Crear equipo',
        team: 'Equipo',
        visit: 'Vistas',
        notes: 'Notas',
        rfv: 'Calidad',
        subscribers: 'Suscriptores',
        status: 'Estado general',
      },
      validations: {
        sumc100: 'La columna debe sumar 100.',
        sumf100: 'La fila debe sumar 100.',
      },
    },
    profile: {
      title: 'Mi perfil',
      password: 'Contraseña',
      updatePasswordTitle: 'Cambiar contraseña',
      change: 'Cambiar',
      messageUpdatePasswordSuccess: 'Contraseña cambiada correctamente',
      messageUpdatePasswordError: 'Error al cambiar la contraseñar',
      messageUpdateAvatarSuccess: 'Avatar actualizado correctamente',
      messageUpdateAvatarError: 'Error al actualizar el avatar',
    },
    settings: {
      name: 'Configuraciones',
      singular_name: 'Configuración',
      fields: {
        name: 'Nombre',
        val: 'Valor',
        type: 'Tipo',
        search: 'Buscar',
      },
    },
    quality: {
      singular_name: 'Quality',
    },
  },
};
export default spanishMessages;
